

const productsActionsFactory = (Dispatcher, CatalogService, StoreStates, MenuStore) => {
  'ngInject';

  const actions = {
    getProducts: (page, size) => {
      Dispatcher.dispatch({
        actionType: 'PRODUCTS_LOAD_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.getProducts(page, size).then((resp) => {
        Dispatcher.dispatch({
          actionType: 'PRODUCTS_LOAD',
          state: StoreStates.STORE_VALID,
          data: {
            products: resp.products,
            pagination: resp.pagination
          }
        });
      }, reason => {
        Dispatcher.dispatch({
          actionType: 'PRODUCTS_LOAD_FAIL',
          state: StoreStates.STORE_FAILED_UPDATE,
          data: {
            reason
          }
        });
      });
    },
    getAllProducts: (page, size) => {
      Dispatcher.dispatch({
        actionType: 'PRODUCTS_LOAD_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.getAllProducts().then((resp) => {
        Dispatcher.dispatch({
          actionType: 'ALL_PRODUCTS_LOAD',
          state: StoreStates.STORE_VALID,
          data: {
            products: resp.products,
            pagination: resp.pagination
          }
        });
      }, reason => {
        Dispatcher.dispatch({
          actionType: 'PRODUCTS_LOAD_FAIL',
          state: StoreStates.STORE_FAILED_UPDATE,
          data: {
            reason
          }
        });
      });
    },
    getCategories: (complete) => {
      Dispatcher.dispatch({
        actionType: 'CATEGORIES_LOAD_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.getCategories(complete).then(categories => {
        Dispatcher.dispatch({
          actionType: 'CATEGORIES_LOAD',
          data: {
            categories
          },
          state: StoreStates.STORE_VALID
        });
      }, reason => {
        Dispatcher.dispatch({
          actionType: 'CATEGORIES_LOAD_FAIL',
          data: {
            reason
          },
          state: StoreStates.STORE_FAILED_UPDATE
        });
      });
    },
    getSubCategories: parentKey => {
      Dispatcher.dispatch({
        actionType: 'SUBCATEGORIES_LOAD_START',
        data: {
          parentKey
        },
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.getSubCategories(parentKey).then(subCategories => {
        Dispatcher.dispatch({
          actionType: 'SUBCATEGORIES_LOAD',
          data: {
            parentKey,
            subCategories
          },
          state: StoreStates.STORE_VALID
        });
      }, reason => {
        Dispatcher.dispatch({
          actionType: 'SUBCATEGORIES_LOAD_FAIL',
          data: {
            reason
          },
          state: StoreStates.STORE_FAILED_UPDATE
        });
      });
    },
    createProduct: product => {
      Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.createProduct(product, product.menus).then(createdProduct => {
        Dispatcher.dispatch({
          actionType: 'SAVEPRODUCT_CREATED',
          data: {
            product: createdProduct
          },
          state: StoreStates.STORE_EXPIRED
        });
        MenuStore.forceExpired();
      }, reason => {
        Dispatcher.dispatch({
          actionType: 'SAVEPRODUCT_FAIL',
          data: {
            reason
          },
          state: StoreStates.STORE_VALID
        });
      });
    },
    editProduct: product => {
      Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.editProduct(product).then(savedProduct => {
        Dispatcher.dispatch({
          actionType: 'SAVEPRODUCT_EDITED',
          data: {
            product: savedProduct
          },
          state: StoreStates.STORE_EXPIRED
        });
      }, reason => {
        Dispatcher.dispatch({
          actionType: 'SAVEPRODUCT_FAIL',
          data: {
            reason
          },
          state: StoreStates.STORE_VALID
        });
      });
    },
    deleteProduct: (productId, businessId) => {
      Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.deleteProduct(productId, businessId).then(() => {
        Dispatcher.dispatch({
          actionType: 'SAVEPRODUCT_DELETED',
          data: {
            productId
          },
          state: StoreStates.STORE_VALID
        });
      }, reason => {
        Dispatcher.dispatch({
          actionType: 'SAVEPRODUCT_FAIL',
          data: {
            reason
          },
          state: StoreStates.STORE_VALID
        });
      });
    },
    showProduct: productId => {
      Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.showProduct(productId).then(() => Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_AVAILABILITY',
        data: {
          productId,
          available: true
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_AVAILABILITY_FAIL',
        data: {
          reason,
          productId
        },
        state: StoreStates.STORE_VALID
      }));
    },
    hideProduct: productId => {
      Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_START',
        state: StoreStates.STORE_PENDING_UPDATE
      });
      CatalogService.hideProduct(productId).then(() => Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_AVAILABILITY',
        data: {
          productId,
          available: false
        },
        state: StoreStates.STORE_VALID
      }), reason => Dispatcher.dispatch({
        actionType: 'SAVEPRODUCT_AVAILABILITY_FAIL',
        data: {
          reason,
          productId
        },
        state: StoreStates.STORE_VALID
      }));
    }
  };

  return actions;
};

export default productsActionsFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/actions/products.actions.factory.js
 **/